<div class="shareContainer">
  <div class="shareModalBox">
    <div class="backArrowSection">
      <ion-icon (click)="dismiss()" name="close-outline"></ion-icon>
    </div>
    <span class="title-share">
      {{ 'thereAre' | translate }} {{ newMatchesInfo.length }} {{ 'newVegmatches' | translate }}
    </span>
    <swiper-container #swiper pagination="true" class="soulsContainer">
      <swiper-slide *ngFor="let match of newMatchesInfo; let i = index">
        <!--| User |-->
        <div class="soulsBackground top">
          <div class="soulsMatch top">
            <img [src]="userData?.profilePic" alt="no me pic">
          </div>
        </div>
    
        <!--| Match |-->
        <div class="soulsBackground bottom">
          <div class="soulsMatch bottom">
            <img [src]="match?.firstPic" alt="no soul pic">
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
    <div class="matchTextContainer">
      <span>{{'vegMatch' | translate}}!</span>
    </div>
    <div class="btnContainer" (click)="openCurrentChat()">
      <div class="btn chat">
        <ion-icon name="chatbubbles" class="chatIcon"></ion-icon>
        <span class="btnText chat">{{'chat' | translate}}</span>
      </div>
    </div>
    <div class="next-back-btn-container">
      <div
      class="btn-back"
      *ngIf="!swiper?.swiper?.isBeginning"
      (click)="!swiper?.swiper?.isBeginning && prevSlide()"
      >
        <span class="btnText back">{{ 'backSurvey' | translate }}</span>
      </div>
      <div
      *ngIf="swiper?.swiper?.isBeginning"
      >
      </div>
      <div
      class="btn-next"
      *ngIf="!swiper?.swiper?.isEnd"
      (click)="!swiper?.swiper?.isEnd && nextSlide()">
        <span class="btnText next">{{'nextSurvey' | translate}}</span>
      </div>
      <div
      class="btn-next"
      *ngIf="swiper?.swiper?.isEnd"
      (click)="dismiss()">
        <span class="btnText next">{{'close' | translate}}</span>
      </div>
    </div>
  </div>
</div>